const SEO = ({
  title = 'MyCleanStudio - Content Compliance Checker for Creators',
  description = 'Check your videos and content against YouTube and TikTok platform guidelines before publishing. AI-powered visual scanning and music detection to keep your content compliant.',
  keywords = 'content compliance, YouTube guidelines, TikTok guidelines, video compliance checker, copyright detection, content moderation, creator tools',
  image = '/logo.png',
  url = '',
  type = 'website',
  siteName = 'MyCleanStudio',
}) => {
  const fullTitle = title.includes('MyCleanStudio') ? title : `${title} | MyCleanStudio`;
  const fullUrl = url ? `https://mycleanstudio.com${url}` : 'https://mycleanstudio.com';
  const fullImageUrl = image.startsWith('http') ? image : `https://mycleanstudio.com${image}`;

  const organizationSchema = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'MyCleanStudio',
    url: 'https://mycleanstudio.com',
    logo: 'https://mycleanstudio.com/logo.png',
    description: 'Content compliance checker for creators to analyze videos before publishing',
    sameAs: [],
  });

  const webAppSchema = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'WebApplication',
    name: 'MyCleanStudio',
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    description: description,
    url: fullUrl,
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
    },
  });

  // React 19 hoists these elements to <head> automatically
  return (
    <>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="MyCleanStudio" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />

      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />

      {/* Structured Data */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: organizationSchema }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: webAppSchema }} />
    </>
  );
};

export default SEO;

